"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_CATEGORY_LEVEL = void 0;
exports.annotateCategoryLevels = annotateCategoryLevels;
exports.canAddSubCategory = canAddSubCategory;
exports.getCategoryLevelById = getCategoryLevelById;
exports.markMaxLevelParentDisabled = markMaxLevelParentDisabled;
exports.validateCategoryParentLevel = validateCategoryParentLevel;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var MAX_CATEGORY_LEVEL = exports.MAX_CATEGORY_LEVEL = 3;
function annotateCategoryLevels(nodes) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return (nodes || []).map(function (node) {
    return _objectSpread(_objectSpread({}, node), {}, {
      level: level,
      children: annotateCategoryLevels(node.children, level + 1)
    });
  });
}
function markMaxLevelParentDisabled(nodes) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_CATEGORY_LEVEL;
  return (nodes || []).map(function (node) {
    var item = _objectSpread(_objectSpread({}, node), {}, {
      disabled: level >= maxLevel
    });
    if (node.children && node.children.length) {
      item.children = markMaxLevelParentDisabled(node.children, level + 1, maxLevel);
    }
    return item;
  });
}
function getCategoryLevelById(id, nodes) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  if (id === null || id === undefined || id === '' || Number(id) === 0) {
    return 0;
  }
  var _iterator = _createForOfIteratorHelper(nodes || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;
      if (String(node.id) === String(id)) {
        return level;
      }
      if (node.children && node.children.length) {
        var found = getCategoryLevelById(id, node.children, level + 1);
        if (found) return found;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return 0;
}
function canAddSubCategory(row) {
  return Number(row.level) < MAX_CATEGORY_LEVEL;
}
function validateCategoryParentLevel(pid, tree) {
  var parentLevel = getCategoryLevelById(pid, tree);
  return parentLevel + 1 <= MAX_CATEGORY_LEVEL;
}